import { CustomFieldType } from '@vend/react-utilities'

export enum GraphQLFulfilmentStatus {
  DISPATCHED = 'DISPATCHED',
  PICKED_UP = 'PICKED_UP',
}

export enum GraphQLPickListType {
  DISPATCH = 'DISPATCH',
  PICKUP = 'PICK_UP',
}

export interface GraphQLCustomField {
  id: string
  name: string
  type: CustomFieldType
  title: string
  visibleInUI: boolean
  printOnReceipt: boolean
}

export interface GraphQLCustomFieldValue {
  name: string
  stringValue?: string | null
  booleanValue?: boolean | null
  integerValue?: string | null
  dateValue?: string | null
  product?: { id: string } | null
  stringArrayValue?: string[] | null
}

export interface GraphQLLineItem {
  id: string
  customFields: GraphQLCustomFieldValue[]
}

export interface GraphQLPicklistLineItem {
  saleLineItem: GraphQLLineItem
}

export interface GraphQLFulfilmentLineItem {
  saleLineItem: GraphQLLineItem
}

export interface GraphQLPartialFulfillmentAddress {
  id: number
  addressLine1: string
  addressLine2: string
  suburb: string
  city: string
  postcode: string
  stateCode: string
  countryCode: string
}
export interface GraphQLPicklist {
  id: string
  type: GraphQLPickListType
  note: string
  outlet?: { id: string } | null
  lineItems: GraphQLPicklistLineItem[]
  billingAddress?: GraphQLPartialFulfillmentAddress
  shippingAddress?: GraphQLPartialFulfillmentAddress
}

export interface GraphQLFulfilment {
  status: GraphQLFulfilmentStatus
  note: string
  lineItems: GraphQLFulfilmentLineItem[]
}

export interface GraphQLSale {
  id: string
  customFields: GraphQLCustomFieldValue[]
  lineItems: GraphQLLineItem[]
  picklists: GraphQLPicklist[]
  fulfillments: GraphQLFulfilment[]
}
